module.exports = __webpack_public_path__ + "static/media/JEIDA clinic.78a0d2c0.jpg";